import { FetchUserAppSettingsResponse } from "./types";
import axios from "../axiosInstance";

export const fetchUserAppSettings =
  async (): Promise<FetchUserAppSettingsResponse> => {
    console.log("[fetchUserAppSettings] Making API call to /api/private/user-app-settings");
    try {
      const response = await axios.get<FetchUserAppSettingsResponse>(
        "/api/private/user-app-settings",
      );

      // Axios response structure debugging
      console.log("[fetchUserAppSettings] Axios response.data type:", typeof response.data);
      console.log("[fetchUserAppSettings] Axios response.data:", response.data);

      // Check if response.data is the FetchUserAppSettingsResponse
      if (response.data && 'data' in response.data) {
        console.log("[fetchUserAppSettings] ✓ response.data has 'data' property");
        console.log("[fetchUserAppSettings] response.data.data:", response.data.data);

        // Check user details
        const userData = response.data.data;
        if (userData && userData.firstName && userData.lastName) {
          console.log(`[fetchUserAppSettings] ✓ User found: ${userData.firstName} ${userData.lastName}`);
        }
      } else {
        console.error("[fetchUserAppSettings] ✗ response.data missing 'data' property!");
        console.error("[fetchUserAppSettings] Keys in response.data:", Object.keys(response.data || {}));
      }

      return response.data;
    } catch (error) {
      console.error("[fetchUserAppSettings] API call failed:", error);
      throw error;
    }
  };
